import { SVGProps } from '@components/Icon/types';

export const Pages = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}>
    <g id="Side Menu Icons">
      <g id="Union">
        <path
          d="M4.22222 4.69841C4.22222 4.42857 4.42857 4.22222 4.69841 4.22222H5.33333C5.60317 4.22222 5.80952 4.42857 5.80952 4.69841C5.80952 4.96825 5.60317 5.1746 5.33333 5.1746H4.69841C4.42857 5.1746 4.22222 4.96825 4.22222 4.69841Z"
          fill={fill}
        />
        <path
          d="M6.7619 4.69841C6.7619 4.42857 6.96825 4.22222 7.2381 4.22222H7.87302C8.14286 4.22222 8.34921 4.42857 8.34921 4.69841C8.34921 4.96825 8.14286 5.1746 7.87302 5.1746H7.2381C6.96825 5.1746 6.7619 4.96825 6.7619 4.69841Z"
          fill={fill}
        />
        <path
          d="M19.3016 4.23876H13.9048C13.6349 4.23876 13.4286 4.44511 13.4286 4.71495C13.4286 4.98479 13.6349 5.19114 13.9048 5.19114H19.3016C19.5714 5.19114 19.7778 4.98479 19.7778 4.71495C19.7778 4.44511 19.5714 4.23876 19.3016 4.23876Z"
          fill={fill}
        />
        <path
          d="M8.34921 10.0952C8.34921 9.8254 8.55556 9.61905 8.8254 9.61905C9.09524 9.61905 9.30159 9.8254 9.30159 10.0952V18.3492C9.30159 18.619 9.09524 18.8254 8.8254 18.8254C8.55556 18.8254 8.34921 18.619 8.34921 18.3492V10.0952Z"
          fill={fill}
        />
        <path
          d="M14.6984 10.0952C14.6984 9.8254 14.9048 9.61905 15.1746 9.61905C15.4444 9.61905 15.6508 9.8254 15.6508 10.0952V18.3492C15.6508 18.619 15.4444 18.8254 15.1746 18.8254C14.9048 18.8254 14.6984 18.619 14.6984 18.3492V10.0952Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 4.06349C2 2.92063 2.92063 2 4.06349 2H19.9365C21.0794 2 22 2.92063 22 4.06349V19.9365C22 21.0794 21.0794 22 19.9365 22H4.06349C2.92063 22 2 21.0794 2 19.9365V4.06349ZM19.9365 2.95238H4.06349C3.44444 2.95238 2.95238 3.44444 2.95238 4.06349V6.44444H21.0476V4.06349C21.0476 3.44444 20.5556 2.95238 19.9365 2.95238ZM21.0476 7.39683H2.95238V19.9365C2.95238 20.5556 3.44444 21.0476 4.06349 21.0476H19.9365C20.5556 21.0476 21.0476 20.5556 21.0476 19.9365V7.39683Z"
          fill={fill}
        />
        <path
          d="M4.22222 4.69841C4.22222 4.42857 4.42857 4.22222 4.69841 4.22222H5.33333C5.60317 4.22222 5.80952 4.42857 5.80952 4.69841C5.80952 4.96825 5.60317 5.1746 5.33333 5.1746H4.69841C4.42857 5.1746 4.22222 4.96825 4.22222 4.69841Z"
          stroke={fill}
          strokeWidth="0.2"
        />
        <path
          d="M6.7619 4.69841C6.7619 4.42857 6.96825 4.22222 7.2381 4.22222H7.87302C8.14286 4.22222 8.34921 4.42857 8.34921 4.69841C8.34921 4.96825 8.14286 5.1746 7.87302 5.1746H7.2381C6.96825 5.1746 6.7619 4.96825 6.7619 4.69841Z"
          stroke={fill}
          strokeWidth="0.2"
        />
        <path
          d="M19.3016 4.23876H13.9048C13.6349 4.23876 13.4286 4.44511 13.4286 4.71495C13.4286 4.98479 13.6349 5.19114 13.9048 5.19114H19.3016C19.5714 5.19114 19.7778 4.98479 19.7778 4.71495C19.7778 4.44511 19.5714 4.23876 19.3016 4.23876Z"
          stroke={fill}
          strokeWidth="0.2"
        />
        <path
          d="M8.34921 10.0952C8.34921 9.8254 8.55556 9.61905 8.8254 9.61905C9.09524 9.61905 9.30159 9.8254 9.30159 10.0952V18.3492C9.30159 18.619 9.09524 18.8254 8.8254 18.8254C8.55556 18.8254 8.34921 18.619 8.34921 18.3492V10.0952Z"
          stroke={fill}
          strokeWidth="0.2"
        />
        <path
          d="M14.6984 10.0952C14.6984 9.8254 14.9048 9.61905 15.1746 9.61905C15.4444 9.61905 15.6508 9.8254 15.6508 10.0952V18.3492C15.6508 18.619 15.4444 18.8254 15.1746 18.8254C14.9048 18.8254 14.6984 18.619 14.6984 18.3492V10.0952Z"
          stroke={fill}
          strokeWidth="0.2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 4.06349C2 2.92063 2.92063 2 4.06349 2H19.9365C21.0794 2 22 2.92063 22 4.06349V19.9365C22 21.0794 21.0794 22 19.9365 22H4.06349C2.92063 22 2 21.0794 2 19.9365V4.06349ZM19.9365 2.95238H4.06349C3.44444 2.95238 2.95238 3.44444 2.95238 4.06349V6.44444H21.0476V4.06349C21.0476 3.44444 20.5556 2.95238 19.9365 2.95238ZM21.0476 7.39683H2.95238V19.9365C2.95238 20.5556 3.44444 21.0476 4.06349 21.0476H19.9365C20.5556 21.0476 21.0476 20.5556 21.0476 19.9365V7.39683Z"
          stroke={fill}
          strokeWidth="0.2"
        />
      </g>
    </g>
  </svg>
);

export const ICON_NAME = 'pages';
